import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Typography, TypographyProps } from '../../components/atoms/Typography/Typography';
import { Tabs } from '../../components/molecules/Tabs/Tabs';
import { useAppSelector } from '../../common/hooks';
import { useState } from 'react';
import FinancialAdvisors from '../../components/organisms/SummaryTab/FinancialAdvisors';
import PortfolioManagement from '../../containers/admin-view/PortfolioManagement';
import ContentManagement from '../../containers/admin-view/content-management';
import { AdminBrandingRevamp } from '../../containers/admin-view/admin-branding';

const PageContainer: any = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 40px 10px 40px',
    flexGrow: 1
}));

export const HeaderText = styled(Typography)<TypographyProps>(({ theme }) => ({
    color: theme.palette.primary.dark,
    margin: `${theme.spacing(4)} 0`,
    display: 'inline-block'
}));

const Admin = () => {
    const { t } = useTranslation();
    const [tabIndex, setTabIndex] = useState('0');
    const userRole = useAppSelector((state) => state?.auth?.user?.userRole);
    const userTenant = useAppSelector((state) => state?.auth?.user?.tenant);
    const isFTAdmin = userRole === 'ftadmin';

    const tabPanels = [
        {
            enabled: true,
            title: t('TEXT_ADMIN_TAB_1'),
            hidden: false,
            children: <FinancialAdvisors userRole={userRole} userTenant={userTenant} />
        },
        {
            enabled: isFTAdmin,
            title: t('TEXT_ADMIN_TAB_PM'),
            hidden: !isFTAdmin,
            children: <PortfolioManagement />
        },
        {
            enabled: isFTAdmin,
            title: t('TEXT_ADMIN_TAB_CM'),
            hidden: !isFTAdmin,
            children: <ContentManagement />
        },
        {
            enabled: isFTAdmin,
            title: t('TEXT_ADMIN_TAB_6'),
            hidden: !isFTAdmin,
            children: <AdminBrandingRevamp />
        }
    ];
    const handleTabChange = (event: React.SyntheticEvent, value: string) => {
        setTabIndex(value);
        return value;
    };

    return (
        <PageContainer>
            <Tabs tabPanels={tabPanels} value={tabIndex} onChange={handleTabChange} />
        </PageContainer>
    );
};

export default Admin;
